/**
 * Read utm_* campaign params off the current URL for first-party attribution.
 *
 * Outbound recovery / trigger-reentry message links carry
 * utm_source/medium/campaign/content (built server-side by the ONE shared helper
 * app/services/messaging/message_attribution.py). Attaching them to the owned
 * landing beacon lets events_raw.params answer "which template/campaign drove
 * this return + payment" first-party (rule 55) — the beacon's params column is a
 * pass-through (deny-list on key shape only), so these keys flow to the warehouse
 * with no allow-list change.
 *
 * Mirrors readReportParams (KundaliResult.helpers.ts): reads the query string AND
 * the hash so a utm survives a hash-routed landing.
 */
export const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
] as const;

export type UtmParams = Partial<Record<(typeof UTM_KEYS)[number], string>>;

export function readUtmParams(): UtmParams {
  if (typeof window === "undefined") return {};
  const sp = new URLSearchParams(window.location.search);
  const hp = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  const out: UtmParams = {};
  for (const key of UTM_KEYS) {
    const value = sp.get(key) || hp.get(key);
    // Keep short, sane values only — never bloat params with an oversized string.
    if (value && value.length <= 100) out[key] = value;
  }
  return out;
}
